import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { BonusAvailable } from '@user/const';
import { BONUS_BALANCE } from '../user-state';

export const LOAD_BONUS_BALANCE = '[CustomUser] Load bonus balance';
export const LOAD_BONUS_BALANCE_FAIL = '[CustomUser] Load bonus balance Fail';
export const LOAD_BONUS_BALANCE_SUCCESS = '[CustomUser] Load bonus balance Success';
export const LOAD_BONUS_BALANCE_RESET = '[CustomUser] Load bonus balance reset';
export const SET_BONUS_BALANCE = '[CustomUser] Set balance bonus';
export class LoadBonusBalance extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_BONUS_BALANCE;

  constructor() {
    super(BONUS_BALANCE);
  }
}

export class LoadBonusBalanceFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_BONUS_BALANCE_FAIL;

  constructor() {
    super(BONUS_BALANCE);
  }
}

export class LoadBonusBalanceSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_BONUS_BALANCE_SUCCESS;

  constructor(public payload: BonusAvailable) {
    super(BONUS_BALANCE);
  }
}

export class LoadBonusBalanceReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_BONUS_BALANCE_RESET;

  constructor() {
    super(BONUS_BALANCE);
  }
}

export class SetBonusBalance implements Action {
  readonly type = SET_BONUS_BALANCE;

  constructor() {}
}
export type BonusBalanceActions = LoadBonusBalance | LoadBonusBalanceSuccess | LoadBonusBalanceFail | SetBonusBalance;
